export const VEHICLE_STATUSES = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  PLANNED: 'PLANNED',
  FULL: 'FULL',
  EN_ROUTE: 'EN_ROUTE',
  OUT_OF_SERVICE: 'OUT_OF_SERVICE',
  FINISHED: 'FINISHED',
});

export const VEHICLE_STATUS_META = Object.freeze({
  [VEHICLE_STATUSES.AVAILABLE]: { label: 'Disponible', variant: 'success' },
  [VEHICLE_STATUSES.PLANNED]: { label: 'Planificado', variant: 'info' },
  [VEHICLE_STATUSES.FULL]: { label: 'Completo', variant: 'warning' },
  [VEHICLE_STATUSES.EN_ROUTE]: { label: 'En recorrido', variant: 'primary' },
  [VEHICLE_STATUSES.OUT_OF_SERVICE]: { label: 'Fuera de servicio', variant: 'danger' },
  [VEHICLE_STATUSES.FINISHED]: { label: 'Finalizado', variant: 'neutral' },
});

export const ACTIVE_VEHICLE_STATUSES = Object.freeze([
  VEHICLE_STATUSES.AVAILABLE,
  VEHICLE_STATUSES.PLANNED,
  VEHICLE_STATUSES.FULL,
  VEHICLE_STATUSES.EN_ROUTE,
]);
